<template>
  <el-row>
    <el-row class="movie-list">
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>视频分区</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onAddCategory">添加</el-button>
          </div>
          <div class="text item">
            <el-tree
              :accordion="true"
              :data="treeNode"
              :props="defaultProps"
              highlight-current
              @node-click="handleNodeClick"
            >
              <span slot-scope="{ node, data }">
                <span :class="data.icon">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="movie-list">
      <el-col :md="12" style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>会员计划</span>
          </div>
          <div class="text item">
            <el-table
              :data="vipPlanList"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="planId"
                label="ID"
              />
              <el-table-column
                prop="name"
                label="名字"
              />
              <el-table-column
                prop="price"
                label="价格(¥)"
              />
              <el-table-column
                prop="duration"
                label="时长(天)"
              />
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :visible.sync="addCategoryDialog"
      width="30%"
      center
    >
      <el-row style="padding-right: 5px; padding-left: 5px; padding-bottom: 5px; text-align: center">
        <el-form ref="form" :model="categoryForm" label-width="80px">
          <el-form-item label="父分区" prop="pid">
            <el-input
              v-model="categoryForm.pid"
              placeholder="父分区"
            />
          </el-form-item>
          <el-form-item label="名字" prop="name">
            <el-input
              v-model="categoryForm.name"
              placeholder="名字"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="plain"
              @click.native="addCategory"
            >更新</el-button>
            <el-button
              type="plain"
              @click.native="addCategoryDialog = false"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { getVipPlan } from '@/api/admin'
import { videoCategories } from '@/api/vod'

export default {
  name: 'AdminCategory',
  mixins: [userMixin],
  data() {
    return {
      treeNode: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value'
      },
      addCategoryDialog: false,
      categoryForm: {
        pid: null,
        name: null
      },
      vipPlanList: []
    }
  },
  created() {
    document.title = '站点分区'
    this.getData()
  },
  methods: {
    getData() {
      getVipPlan().then(resp => {
        if (resp.code === 0) {
          this.vipPlanList = resp.data
        } else {
          this.$message.warning(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })

      videoCategories().then(resp => {
        if (resp.code === 0) {
          this.treeNode = resp.data
        } else {
          this.$message.warning(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // ****************************************************************************************************************
    handleNodeClick() {
      this.$message.info('handleNodeClick')
    },
    onAddCategory() {
      this.addCategoryDialog = true
    },
    addCategory() {
      this.addCategoryDialog = false
      this.$message.info('add category')
    }
  }
}
</script>

<style>
</style>
